import { Outlet } from "react-router-dom";

const ProfilePage = () => {
  return <Outlet />;
};

export default ProfilePage;
